import React, { Fragment, useState, useEffect, memo, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
import tools from "../../components/tools/tools";
import TablaPro from "../../components/tabla";
import ModalEditarCarnet from "./modal_editar";
import ModalImpresion from "./modal_impresion";
import ImgServerr from "../../assets/img/server.gif";
import configImg from "../../assets/img/configuracion.png";
import MenuImg from "../../assets/img/menu.png";
import Select from "react-select";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Loader from '../common/loader';
import { ReactInternetSpeedMeter } from 'react-internet-meter'

const Default = (usuario) => {
    // const history = useNavigate();
    let server = ''
    const [estatusConexion, setEstatusConexion] = useState(false)
    const [tipoRegistro, setTipoRegistro] = useState(1)
    const [tipoCarnets, setTipoCarnet] = useState([])
    const [selectTipoCarnet, setSelectTipoCarnet] = useState([])
    const [modalEditar, setModalEditar] = useState({ estado: false })
    const [modalImpresion, setModalImpresion] = useState({ estado: false, datos: [] })
    const [esRefresh, setEsRefresh] = useState(true)
    const [qrSelected, setQrSelected] = useState({ estado: false, escaneo: false, datos: {} })
    const [esImprimir, setEsImprimir] = useState(false)
    const [esImprimirDinamica, setEsImprimirDinamica] = useState(false)
    const [filtros, setFiltros] = useState({b: ''})
    const [manualSearchEnabled, setManualSearchEnabled] = useState(false); 
    const [switchBuscador, setSwitchBuscador] = useState(true);
    const [user, setUser] = useState(null)
    const [isMesaExpositor, setIsMesaExpositor] = useState(false); // Add state for "Es Mesa Expositor"
    const [speed, setSpeed] = useState('0.0');
    const [color, setColor] = useState('#000000');
    let timeout, busqueda_pendiente = '';
    let textQr = '', idTimemOut = null;
    const alertSwal = withReactContent(Swal);
    let debounceTimeout = null;
    let previewWindow = null; // Declare previewWindow globally
    let previewTimeout = null; // Declare previewTimeout globally

    const evaluarEscribiendo = (e) => {
        if (timeout) {
            clearTimeout(timeout)
        }

        busqueda_pendiente = e.target.value;

        //pagina: busqueda_pendiente.length?0:null,
        timeout = setTimeout(() => {
            setFiltros((s) => ({ ...s, b: busqueda_pendiente, FOLIO_RC: '', ID_RC: '', ID_RAC: '', tipoFiltro: 'buscador'}))
        }, 1000)
    }

    const onDecencriptar = async (e) => {
        if(!window.eventos){
            return
        }

        let dec = await window.eventos.decencriptar(e)
        console.log(dec)
        let estatus = false

        if(dec.ID_RAC){
            estatus = true
            setFiltros((s) => ({ ...s, FOLIO_RC: '', ID_RC: '', ID_RAC: dec.ID_RAC, tipoFiltro: 'buscador'}))
        }

        if(dec.ID_RC){
            estatus = true
            setFiltros((s) => ({ ...s, FOLIO_RC: dec.ID_RC, ID_RC: '', ID_RAC: '', tipoFiltro: 'buscador'}))
        }

        if(dec.FOLIO_RC){
            estatus = true
            setFiltros((s) => ({ ...s, FOLIO_RC: dec.FOLIO_RC, ID_RC: '', ID_RAC: '', tipoFiltro: 'buscador'}))
        }

        if(estatus == false){
            evaluarEscribiendo({ target: { value: '' } })
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `[1] El QR no fue encontrado, si persiste el problema intenta buscar por (Nombre, Apellidos, Correo o Empresa).`,
                time: 5, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        if(dec.ID_RC || dec.ID_RAC || dec.FOLIO_RC){
            fetch('/rt_mesa_registro', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({...dec})
            })
            .then((response) => response.json())
            .then((response) => {                
                if(!response.result.length){
                    evaluarEscribiendo({ target: { value: '' } })
                    return tools.notie.alert({
                        type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral'],
                        text: `[2] El QR no fue encontrado, si persiste el problema intenta buscar por (Nombre, Apellidos, Correo o Empresa).`,
                        time: 5, // optional, default = 3, minimum = 1,
                        position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                    }) 
                }

                // if (previewWindow && !previewWindow.closed) {
                //     previewWindow.close();
                //     clearTimeout(previewTimeout); // Clear the timeout for the previous window
                // }

                // previewWindow = window.open('', '_blank', 'width=600,height=240');
                // previewWindow.document.write('<html><body><h1>Preview Content</h1></body></html>');
                // previewWindow.document.close();

                // previewTimeout = setTimeout(() => {
                //     if (previewWindow && !previewWindow.closed) {
                //         previewWindow.close();
                //     }
                // }, 10000);

                console.log(210011, response.result[0].ESTATUS_DPG)
                let estatusPago = response.result[0].ESTATUS_DPG

                if (estatusPago !== 2 && estatusPago !== 5) {
                    alertSwal.fire({
                        title: `El estatus de pago del asistente es "${response.result[0].ESTATUS_DPG_TEXT}".`,
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    });
                    return;
                }

                setModalImpresion((s) => ({
                    ...s,
                    estado: !s.estado,
                    datos: response.result.map((v) => ({...v, FOLIO_RC: dec.ID_RC}))
                }))
            })
        }
    }

    const onImprimir = async (datos) => {
        setEsImprimir(datos.ID_RAC)

        if(!window.eventos){
            return
        }

            console.log(210012, datos)
        let response = await window.eventos.imprimir(datos)
        console.log(210013, response)

        if(!response.estado){
            setEsImprimir(false)

            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Error de impresión, revisa que la impresora este conectada correctamente, no tenga etiquetas atascadas o este repetido el dispositivo. Si persiste el error solicita apoyo al equipo de Prointernet.`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        setModalImpresion((s) => ({
            ...s,
            datos: s.datos.map((v) => v.ID_RAC === response.datos.ID_RAC? {...v, IMPRIMIO_CARNET_RAC: 1}: v)
        }))
        
        // Preparar datos para enviar
        const datosParaEnviar = {
            ...response.datos, 
            alert: 0, 
            motivo: datos.motivo_impresion, 
            COMENTARIO_IMPRESION_RAC: datos.COMENTARIO_IMPRESION_RAC
        };
        
        console.log('Datos que se enviarán al servidor:', datosParaEnviar);
        
        fetch('/rt_mesaregistro_imprimir_carnet', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(datosParaEnviar)
        })
        .then((response) => response.json())
        .then((response) => {
            console.log('Respuesta del servidor al guardar impresión:', response)

            setEsImprimir(false)

            if(response.estado === 0){
                console.error('Error detallado del servidor:', response)
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Error al intentar guardar el estatus de impresión, comunica al equipo de Prointernet para darle una pronta solución.`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            setFiltros((s) => ({...s, estado: !s.estado, tipoFiltro: 'buscador'}))

            return tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Imprimiendo ${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    async function fetchBienvenida(datos) {
        setEsImprimir(datos.ID_RAC);

        if(!window.eventos) {
            return;
        }

        let response = await window.eventos.imprimir_bienvenida(datos);
        
        if(!response.estado){
            setEsImprimir(false);

            return tools.notie.alert({
                type: 'warning',
                text: `Error de impresión, revisa que la impresora este conectada correctamente, no tenga etiquetas atascadas o este repetido el dispositivos. Si persiste el error solicita apoyo al equipo de Prointernet`,
                time: 3,
                podiyion: 'top'
            })
        }

        setModalImpresion((s) => ({
            ...s,
            datos: s.datos.map((v) => v.ID_RAC === response.datos.ID_RAC? {...v, IMPRIMIO_CARNET_RAC: 1}: v)
        }));

        fetch('/rt_mesaregistro_imprimir_carnet', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(response.datos)
        })
        .then((response) => response.json())
        .then((response) => {
            setEsImprimir(false)

            if(response.estado === 0){
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Error al intentar guardar el estatus de impresión, comunica al equipo de Prointernet para darle una pronta solución.`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            setFiltros((s) => ({...s, estado: !s.estado, tipoFiltro: 'buscador'}))

            return tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Imprimiendo ${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }
    const onImprimirBienvenida = async (datos) => {
        fetch('/rt_bienvenida_impreso', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(datos)
        }).then(response => response.json())
        .then((response) => {
            if(response.isImpreso){
                alertSwal.fire({
                    title: 'El asistente ya fue impreso ¿Quiere imprimirlo nuevamente?',
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: "Imprimir",
                    preConfirm: async () => {
                        await fetchBienvenida(datos);
                    }
                }).then((result) => {
                    if(result.isConfirmed) {
                        return tools.notie.alert({
                            type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                            text: `Imprimiendo ${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}`,
                            time: 2, // optional, default = 3, minimum = 1,
                            position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                        })
                    }
                })
            }else{
                return fetchBienvenida(datos)
            }
        })
    }

    async function fetchDinamica(datos) {
        setEsImprimirDinamica(true);

        if(!window.eventos) return;
        
        let response = await window.eventos.imprimir_dinamica(datos);

        if(!response.estado){
            setEsImprimirDinamica(false);

            return tools.notie.alert({
                type: 'warning',
                text: `Error de impresión, revisa que la impresora este conectada correctamente, no tenga etiquetas atascadas o este repetido el dispositivos. Si persiste el error solicita apoyo al equipo de Prointernet`,
                time: 3,
                podiyion: 'top'
            })
        }

        setModalImpresion((s) => ({
            ...s,
            datos: s.datos.map((v) => v.ID_RAC === response.datos.ID_RAC ? {...v, IMPRIMIO_CARNET_RAC: 1}: v)
        }))

        fetch('/rt_mesaregistro_imprimir_dinamica', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(response.datos)
        })
        .then((response) => response.json())
        .then((response) => {
            setEsImprimirDinamica(false)

            if(response.estado === 0){
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Error al intentar guardar el estatus de impresión, comunica al equipo de Prointernet para darle una pronta solución.`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            }

            setFiltros((s) => ({...s, estado: !s.estado, tipoFiltro: 'buscador'}))

            return tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Imprimiendo ${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    const onImprimirDinamica = async (datos) => {
        fetch('/rt_dinamica_impreso', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(datos)
        }).then(response => response.json())
        .then((response) => {
            console.log(response)
            if(response.isImpreso){
                alertSwal.fire({
                    title: 'El asistente ya fue impreso ¿Quiere imprimirlo nuevamente?',
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: "Imprimir",
                    preConfirm: async () => {
                        await fetchDinamica(datos);
                    }
                }).then((result) => {
                    if(result.isConfirmed) {
                        return tools.notie.alert({
                            type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                            text: `Imprimiendo ${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}`,
                            time: 2, // optional, default = 3, minimum = 1,
                            position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                        })
                    }
                })
            }else{
                return fetchDinamica(datos)
            }
        })
    }

    const onEntregaKit = (datos) => {
        fetch('/rt_mesaregistro_entrega_kit', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(datos)
        })
        .then((response) => response.json())
        .then((response) => {
            // setFiltros((s) => ({...s, estado: !s.estado, tipoFiltro: 'buscador'}))
            setEsRefresh((s) => !s)

            return tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Entregando kit a <strong>${datos.NOMBRES_DP} ${datos.APELLIDOS_DP}</strong>`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    const onFiltroTipoCarnet = (datos) => {
        setSelectTipoCarnet(datos);

        if (!datos || datos.length === 0) {
            setFiltros((s) => ({ ...s, pagina: 0, b: '', FOLIO_RC: '', ID_RC: '', tipoCarnets: null, ID_RAC: '', tipoFiltro: 'buscador'}));
            return;
        }

        let _tipoCarnets = datos.map((v) => v.value);
        setFiltros((s) => ({ ...s, pagina: 0, b: '', FOLIO_RC: '', ID_RC: '', ID_RAC: '', tipoCarnets: _tipoCarnets, tipoFiltro: 'buscador'}));
    };

    const regex = /(?=.*?[0-9])/

    useEffect(() => {
        setUser(usuario)
    }, [usuario]);

    useEffect(() => {
        console.log(5455, user)
    }, [user]);

    useEffect(() => {
        let isS = true;
        // window.api.recieve("tipoQr", (args) => {
        //     //handle on download-progress event
        // });
        fetch('/rt_catalogos_tipos_carnet', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        })
        .then((response) => response.json())
        .then((response) => {
            if(isS){
                setTipoCarnet(response.catTipoCarnets)
            }
        })
        return () => (isS = false);
    }, []);

    useEffect(() => {
        let isS = true;
        if(window.eventos){
            console.log(234236435, user)
            window.eventos.tipoRegistro(user)
            .then((response) => {
                if(isS){
                    setTipoRegistro(response)
                }
            })
            .catch(() => {
                if(isS){
                    setTipoRegistro(1)
                }
            })
        }
        return () => (isS = false);
    }, [user])

    useEffect(() => {
        async function loadConfiguration() {
            // setManualSearchEnabled(user.manualSearch || false); 
            // setIsMesaExpositor(user.isMesaExpositor || false); 
            // setFiltros((s) => ({ ...s, manualSearch: user.manualSearch || false, isMesaExpositor: user.isMesaExpositor || false }));
            if (window.eventos) {
                const response = await window.eventos.leerConfiguracion();
                if (response.estado === 'OK' && response.datos) {
                    const config = response.datos;
                    setManualSearchEnabled(config.manualSearch || false); 
                    setIsMesaExpositor(config.isMesaExpositor || false); // Load "Es Mesa Expositor" state

                    // Update filtros with configuration data
                    setFiltros((s) => ({ ...s, manualSearch: config.manualSearch || false, isMesaExpositor: config.isMesaExpositor || false }));
                }
            }
        }
        loadConfiguration();
    }, [user]);

    const headersRegistro = [
        {
            nombre: 'Folio / Id', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return <div style={{width: '10em'}}>
                    <strong>{d.FECHA_ALTA_RAC_TEXT}</strong><br />
                    <span className="text-info"><strong>{d.ID_RC}</strong>-<strong>{d.ID_RAC}</strong></span>
                </div>
            }
        },
        {
            nombre: 'Asistente/Empresa', tipo: 'html', texto: 'NOMBRES_DP', html: (d) => {
                return <div style={{width: '25em'}}>
                    <strong>{d.NOMBRES_DP} {d.APELLIDOS_DP}</strong><br />
                    <span className="text-info"><strong>{d.EMPRESA}</strong></span>
                </div>
            }
        },
        {
            nombre: 'Contacto/Dirección', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return <div> 
                        {d.CORREO_DP ? <Fragment><strong>{d.CORREO_DP}</strong><br /></Fragment>:<Fragment>Sin correo<br/></Fragment>}
                        {d.WHATSAPP_DP?<Fragment>Cel. {d.WHATSAPP_DP}<br/></Fragment>:<Fragment>Sin teléfono<br/></Fragment>}
                        {d.ESTADO ? <Fragment>{d.ESTADO}, Cd. {d.CIUDAD}</Fragment>:<Fragment>Sin dirección<br/></Fragment>}
                </div>
            }
        },
        {
            nombre: 'Tipo carnet', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return <div>
                        {d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1001? 
                            <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                        :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1002?
                            <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                        :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1003?
                            <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                        :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1004? 
                            <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                        :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1005?
                            <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                        :d.TIPO_CARNET === 2?
                            <img src="/talleres.jpg" width={150} />
                        :d.TIPO_CARNET === 3? 
                            <img src="/Expositor.png" width={150} />
                        :d.TIPO_CARNET === 4? 
                            <img src="/Invitado-Especial.png" width={150} />
                        :d.TIPO_CARNET === 5? 
                            <img src="/prensa.jpg" width={150} />
                        :d.TIPO_CARNET === 6? 
                            <img src="/Staff.png" width={150} />
                        :d.TIPO_CARNET === 7 || d.TIPO_CARNET === 8? 
                            <img src="/cena.jpg" width={150} />
                        :d.TIPO_CARNET === 11? 
                            <img src="/Ponente.png" width={150} />
                        :d.TIPO_CARNET === 12? 
                        <img src="/patrocinador.jpg" width={150} />
                        :d.TIPO_CARNET === 13? 
                        <img src="/claec.jpg" width={150} />
                        :d.TIPO_CARNET === 9? 
                        <img src="/conferencias.jpg" width={150} />
                        :d.TIPO_CARNET === 8? 
                        <img src="/cena.jpg" width={150} />
                        :d.TIPO_CARNET === 15?
                        <img src="/convencionista-soloCB.jpg" width={150} />
                        :d.TIPO_CARNET === 16?
                        <img src="/convencionista-sinC.jpg" width={150} />
                        :d.TIPO_CARNET === 17?
                        <img src="/apoyo-speaker.jpg" width={150} />
                        : <h5><span className="badge badge-primary">Carnet {d.TIPO_CARNET_TEXT}</span></h5>}
                    </div>
            }
        },
        {
            nombre: 'Entrega kit', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return d.KIT_ENTREGADO_RAC ?
                    <h6><span className="badge badge-success"><span>{d.KIT_ENTREGADO_TEXT}</span><br/><span className="badge badge-light mt-2" style={{fontSize: 10}}>{d.FECHA_KIT_ENTREGADO_TEXT}</span></span></h6>
                    :
                    <h6><span className="badge badge-warning">{d.KIT_ENTREGADO_TEXT}</span></h6>
            }
        },
        {
            nombre: 'Impresión acceso', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return <div>
                    <Fragment>
                        {d.IMPRIMIO_CARNET_RAC ?
                            <h6><span className="badge badge-success"><span>{d.IMPRIMIO_CARNET_TEXT}</span><br/><span className="badge badge-light mt-2" style={{fontSize: 10}}>{d.ULTIMA_IMPRESION}</span></span></h6>
                            :
                            <h6><span className="badge badge-warning">{d.IMPRIMIO_CARNET_TEXT}</span></h6>
                        }
                    </Fragment>
                </div>
            }
        },
        // {
        //     nombre: 'Impresión dinamica', tipo: 'html', texto: 'ID_RAC', html: (d) => {
        //         return <div>
        //             <Fragment>
        //                 {d.IMPRIMIO_CARNET_RAC ?
        //                     <h6><span className="badge badge-success"><span>{d.IMPRIMIO_CARNET_TEXT}</span><br/><span className="badge badge-light mt-2" style={{fontSize: 10}}>{d.ULTIMA_IMPRESION}</span></span></h6>
        //                     :
        //                     <h6><span className="badge badge-warning">{d.IMPRIMIO_CARNET_TEXT}</span></h6>
        //                 }
        //             </Fragment>
        //         </div>
        //     }
        // },
        {
            nombre: 'Estatus pago', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                return <div>
                    <Fragment>
                        <div style={{textTransform: 'uppercase'}}>
                            {d.ESTATUS_DPG === -1 ?
                            <h6><span className="badge badge-dark">{d.ESTATUS_DPG_TEXT} Pago</span></h6>
                            : d.ESTATUS_DPG === 0 ?
                            <h6><span className="badge badge-danger">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                            : d.ESTATUS_DPG === 1 ?
                            <h6><span className="badge badge-light">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                            : d.ESTATUS_DPG === 2 ?
                            <h6><span className="badge badge-success">{d.ESTATUS_DPG_TEXT}</span></h6>
                            : d.ESTATUS_DPG === 3 ?
                            <h6><span className="badge badge-warning">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                            : d.ESTATUS_DPG === 4 ?
                            <h6><span className="badge badge-dark">{d.ESTATUS_DPG_TEXT}</span></h6>
                            : d.ESTATUS_DPG === 5 ?
                            <h6><span className="badge badge-info">{d.ESTATUS_DPG_TEXT}</span></h6>
                            :d.ESTATUS_DPG === 6 ?
                            <h6><span className="badge badge-info">{d.ESTATUS_DPG_TEXT}</span></h6>
                            :'Sin estatus'}
                        </div>
                    </Fragment>
                </div>
            }
        },
        // { nombre: 'Fecha', tipo: 'individual', texto: 'FECHA_ALTA_RAC_TEXT' },
        {
            nombre: 'Detalles', tipo: 'html', texto: 'Detalle',
            html: (datos) => {
                return <div>
                    <div className="btn-group dropstart dropleft">
                        <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Opciones
                        </button>
                        <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                        >
                            <li>
                                <a className="dropdown-item" href="#"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setModalImpresion((s) => ({
                                            ...s,
                                            estado: !s.estado,
                                            datos: [{...datos, TIPO_QR: 1}]
                                        }))
                                    }}
                                >Imprimir carnet</a>
                            </li>
                            <li>
                                <a className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        onEntregaKit(datos)                                                         
                                    }}
                                >Entrega de kit</a>
                            </li>
                            <li>
                                <a className="dropdown-item" href="#"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setModalEditar((s) => ({
                                            ...s,
                                            estado: !s.estado,
                                            datos
                                        }))
                                    }}
                                >Editar asistente</a></li>
                            <li>
                                <a className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        window.location.href = '/mesaregistro/editar/'+datos.ID_RC                                                           
                                    }}
                                >Detalle del registro</a>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        }
    ]
    
    const memoizedBody = useMemo(() => {
        const baseFilters = { ...filtros, tipoRegistro };
        if (isMesaExpositor) {
            return { ...baseFilters, tipoCarnets: [3, 7] }; // Filter for "Expositores" and "Expositores con Cena"
        }
        return baseFilters;
    }, [filtros, tipoRegistro, isMesaExpositor]);
    const memoizedRefresh = useMemo(() => esRefresh, [esRefresh]);

    useEffect(() => {
        console.log(115511, isMesaExpositor)
    }, [isMesaExpositor]);

    const WifiIcon = ({ color = '#000000', size = 30 }) => (
        <svg
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 20.00 20.00"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="none"
        >
            <g strokeWidth="2" fill="none" fillRule="evenodd">
            <g transform="translate(-60.000000, -3681.000000)" fill={color}>
                <g transform="translate(56.000000, 160.000000)">
                <path d="M11.9795939,3535.00003 C11.9795939,3536.00002 12.8837256,3537 14,3537 C15.1162744,3537 16.0204061,3536.00002 16.0204061,3535.00003 C16.0204061,3532.00008 11.9795939,3532.00008 11.9795939,3535.00003 M9.71370846,3530.7571 L11.1431458,3532.17208 C12.7180523,3530.6121 15.2819477,3530.6121 16.8568542,3532.17208 L18.2862915,3530.7571 C15.9183756,3528.41413 12.0816244,3528.41413 9.71370846,3530.7571 M4,3525.10019 L5.42842711,3526.51516 C10.1551672,3521.83624 17.8448328,3521.83624 22.5715729,3526.51516 L24,3525.10019 C18.4772199,3519.63327 9.52278008,3519.63327 4,3525.10019 M21.1431458,3527.92914 L19.7147187,3529.34312 C16.5638953,3526.22417 11.4361047,3526.22417 8.28528134,3529.34312 L6.85685423,3527.92914 C10.8016971,3524.0242 17.1983029,3524.0242 21.1431458,3527.92914" />
                </g>
            </g>
            </g>
        </svg>
    );

    function getSpeed(){
        setColor('#000000')
        setEstatusConexion(!estatusConexion)
        if(estatusConexion == true){
            speed > 30 ? setColor('#259e00') : setColor('#db0000')
        }else{
            setColor('#000000')
            setSpeed('0.0')
        }
    }

    useEffect(() => {
        if(speed){
            if(estatusConexion == true){
                speed > 30 ? setColor('#259e00') : setColor('#db0000')
            }else{
                setColor('#000000')
                setSpeed('0.0')
            }
        }else{
            setColor('#000000')
            setSpeed('0.0')
        }
    }, [speed])

    return (
        <div>
            <Fragment>
                <Loader status={user}/>
                <div className="col-sm-12 mt-3"
                    onClick={() => {
                        if (qrSelected.estado) {
                            setQrSelected((v) => ({ ...v, estado: false }))
                        }
                    }}
                >
                <div className="card">
                    <div className="card-header" style={{paddingTop: 0, paddingBottom: 0}}>
                        <div className='row'>
                                {/* <div className='col-sm-12 mb-2 d-flex justify-content-center'>
                                    <h5>Mesa de Registro</h5>
                                </div> */}
                                <div className="d-flex" style={{position: 'absolute', zIndex: '2'}}>
                                    <div className="col-xl-8 p-0 d-flex" style={{marginTop: 0}}>
                                        <a style={{cursor: 'pointer'}} onClick={() => {getSpeed()}}>
                                            <WifiIcon id="iconWifi" color={color}/>
                                            <div id="divInternet">
                                                {estatusConexion == true ? 
                                                    <>
                                                        <ReactInternetSpeedMeter
                                                            txtSubHeading="Checking the speed"
                                                            outputType="empty"
                                                            customClassName={null}
                                                            txtMainHeading="Opps..."
                                                            pingInterval={4000} // milliseconds
                                                            thresholdUnit="megabyte" // "byte" , "kilobyte", "megabyte"
                                                            threshold={1000000}
                                                            imageUrl="https://mesa.nexohidrico.com/LOGOTIPO-PROINTERNET.png"
                                                            downloadSize="1781287" //bytes
                                                            callbackFunctionOnNetworkDown={(speed) => ''}
                                                            callbackFunctionOnNetworkTest={(speed) => setSpeed(speed)}
                                                        />
                                                        <p id="internetSpeed" style={{fontSize: 12, marginTop: -10, marginLeft: -8, marginRight: -18}}>{speed ? speed : '0.0'} MB</p>
                                                    </>
                                                :
                                                    ''
                                                }
                                            </div>
                                        </a>
                                    </div>
                                    {/* {user?.usuario?.ID_US !== 1 ? '' :  */}
                                        <div className="col-xl-8 p-0 m-0" style={{cursor: 'pointer', zIndex: -100}}>
                                            <div className="dropdown" style={{ marginTop: -7}}>
                                                <img 
                                                    src={MenuImg} 
                                                    width={40} 
                                                    id="dropdownMenuButton" 
                                                    data-bs-toggle="dropdown" 
                                                    aria-expanded="false" 
                                                />
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <li>
                                                        <a 
                                                            className="dropdown-item" 
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                fetch('/rt_config_password', {
                                                                        method: 'POST',
                                                                        headers: {'Content-Type': 'application/json'},
                                                                        body: ''
                                                                    })
                                                                    .then((response) => response.json())
                                                                    .then((data) => {
                                                                        console.log(123, data)
                                                                        alertSwal.fire({
                                                                            title: 'Ingrese la clave de acceso',
                                                                            input: 'password',
                                                                            inputAttributes: {
                                                                                autocapitalize: 'off'
                                                                            },
                                                                            showCancelButton: true,
                                                                            confirmButtonText: 'Acceder',
                                                                            showLoaderOnConfirm: true,
                                                                            preConfirm: (password) => {
                                                                                if (password === data.password) {
                                                                                    window.location.replace('/mesaregistro/configuracion');
                                                                                } else {
                                                                                    Swal.showValidationMessage('Clave incorrecta');
                                                                                }
                                                                            },
                                                                            allowOutsideClick: () => !Swal.isLoading()
                                                                        });
                                                                    });
                                                            }}
                                                        >
                                                            Configuración Impresoras
                                                        </a>
                                                    </li>
                                                    {/* {user?.usuario?.ID_US !== 1 ? '' :         */}
                                                        <>
                                                            <li>
                                                                <a 
                                                                    className="dropdown-item" 
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        fetch('/rt_etiqueta_config_password', {
                                                                                method: 'POST',
                                                                                headers: {'Content-Type': 'application/json'},
                                                                                body: ''
                                                                            })
                                                                            .then((response) => response.json())
                                                                            .then((data) => {
                                                                                alertSwal.fire({
                                                                                    title: 'Ingrese la clave de acceso',
                                                                                    input: 'password',
                                                                                    inputAttributes: {
                                                                                        autocapitalize: 'off'
                                                                                    },
                                                                                    showCancelButton: true,
                                                                                    confirmButtonText: 'Acceder',
                                                                                    showLoaderOnConfirm: true,
                                                                                    preConfirm: (password) => {
                                                                                        if (password === data.password) {
                                                                                            window.location.replace('/mesaregistro/etiquetas_config');
                                                                                        } else {
                                                                                            Swal.showValidationMessage('Clave incorrecta');
                                                                                        }
                                                                                    },
                                                                                    allowOutsideClick: () => !Swal.isLoading()
                                                                                });
                                                                            });
                                                                    }}
                                                                >
                                                                    Configuración Etiquetas
                                                                </a>
                                                            </li> 
                                                            <li>
                                                                <a 
                                                                    className="dropdown-item" 
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        fetch('/rt_estadisticas_password', {
                                                                                method: 'POST',
                                                                                headers: {'Content-Type': 'application/json'},
                                                                                body: ''
                                                                            })
                                                                            .then((response) => response.json())
                                                                            .then((data) => {
                                                                                alertSwal.fire({
                                                                                    title: 'Ingrese la clave de acceso',
                                                                                    input: 'password',
                                                                                    inputAttributes: {
                                                                                        autocapitalize: 'off'
                                                                                    },
                                                                                    showCancelButton: true,
                                                                                    confirmButtonText: 'Acceder',
                                                                                    showLoaderOnConfirm: true,
                                                                                    preConfirm: (password) => {
                                                                                        if (password === data.password) {
                                                                                            window.location.replace('/mesaregistro/estadistica');
                                                                                        } else {
                                                                                            Swal.showValidationMessage('Clave incorrecta');
                                                                                        }
                                                                                    },
                                                                                    allowOutsideClick: () => !Swal.isLoading()
                                                                                });
                                                                            });
                                                                    }}
                                                                >
                                                                    Estadisticas
                                                                </a>
                                                            </li>
                                                        </>
                                                    {/* } */}
                                                    <li>
                                                        <a 
                                                            className="dropdown-item" 
                                                            href="/cerrar-sesion"
                                                        >
                                                            Cerrar sesión
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    {/* } */}
                                </div>
                                <div className="col-xl-12 p-0">
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <h3 className="titulo-expo">NEXOHIDRICO</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-header p-0">
                            <div className="row" style={{position: 'absolute', right: '0%', top: '0%'}}>
                                <div className="col-md-12 d-flex justify-content-end align-items-center">
                                    <a href="#" style={{backgroundColor: qrSelected.estado ? '#39F203' : 'white'}}
                                        onKeyDown={(e) => {
                                            e.preventDefault()
                                            if (e.key !== 'Enter') {
                                                textQr += e.key
                                            }
                                        }}
                                        onKeyUp={() => {
                                            window.clearTimeout(idTimemOut)
                                            idTimemOut = setTimeout(async () => {
                                                if (textQr.length) {
                                                    // window.api.send("imprimir", {textQr, datos: { nombre: 'Daniel' } });
                                                    await onDecencriptar({ textQr })
                                                    textQr = ''
                                                }
                                            }, 1000)
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setQrSelected((v) => ({ ...v, estado: true }))
                                        }}>
                                        <img src="/scan.png" width={60} />
                                    </a>
                                </div>
                            </div>
                            <div className='row'>
                                {/* <div className='col-sm-12 mb-2 d-flex justify-content-center'>
                                    <h5>Mesa de Registro</h5>
                                </div> */}
                                <div className="col-xl-8 mb-2 mt-3">
                                    <div className="row">
                                        <div className="col-md-7">
                                            <div className="d-flex">
                                                <label style={{ fontWeight: 600, fontSize: 16 }} htmlFor="buscar">
                                                    Buscador
                                                </label>
                                                <div style={{ position: "relative", display: "flex", justifyContent: "end", alignItems: "center", width: "100%" }}>
                                                    <label style={{ fontWeight: 600, fontSize: 14 }}>Búsqueda manual</label>&ensp;
                                                    <label style={{ position: "relative", display: "inline-block", cursor: manualSearchEnabled ? "pointer" : "not-allowed" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={switchBuscador}
                                                            onChange={() => {
                                                                if (manualSearchEnabled) {
                                                                    setSwitchBuscador(!switchBuscador);
                                                                }
                                                            }}
                                                            style={{
                                                                appearance: "none",
                                                                width: "40px",
                                                                height: "20px",
                                                                background: switchBuscador ? "#4cae9d" : "#ccc",
                                                                borderRadius: "20px",
                                                                position: "relative",
                                                                transition: "background 0.3s",
                                                                cursor: manualSearchEnabled ? "pointer" : "not-allowed"
                                                            }}
                                                            disabled={!manualSearchEnabled}
                                                        />
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                width: "16px",
                                                                height: "16px",
                                                                background: "white",
                                                                borderRadius: "50%",
                                                                top: "2px",
                                                                right: switchBuscador ? "2px" : "22px",
                                                                transition: "right 0.3s"
                                                            }}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="input-group">
                                                <input
                                                    id="input_buscador"
                                                    type="text"
                                                    className="form-control"
                                                    name="buscar"
                                                    aria-label=""
                                                    aria-describedby="basic-addon1"
                                                    placeholder="Buscar por (nombres, apellidos, correo electrónico y nombre de empresa)"
                                                    onInput={switchBuscador ? () => {} : evaluarEscribiendo}
                                                    onKeyDown={
                                                        switchBuscador ? 
                                                            (e) => {
                                                                if (e.key === "Enter") {
                                                                    e.preventDefault(); 
                                                                    if (debounceTimeout) return; // Prevent spamming
                                                                    debounceTimeout = setTimeout(() => {
                                                                        debounceTimeout = null; // Reset debounce
                                                                    }, 1000); // 1-second debounce

                                                                    if (!e?.target || !e.target?.value || e.target?.value.trim() === "") {
                                                                        return; 
                                                                    }
                                                                    setFiltros((s) => ({ 
                                                                        ...s, 
                                                                        b: e?.target?.value, 
                                                                        FOLIO_RC: '', 
                                                                        ID_RC: '', 
                                                                        ID_RAC: '', 
                                                                        tipoFiltro: 'buscador' 
                                                                    }));
                                                                }
                                                            }
                                                        : () => {}
                                                    }
                                                    style={switchBuscador ? {borderRight: '0'} : {}}
                                                />
                                                {
                                                    switchBuscador ? 
                                                        <span 
                                                            className="input-group-text" 
                                                            onClick={
                                                                switchBuscador ? 
                                                                    () => {
                                                                        const inputElement = document.getElementById('input_buscador');
                                                                        if (!inputElement || !inputElement.value.trim()) {
                                                                            return;
                                                                        }
                                                                        setFiltros((s) => ({ 
                                                                            ...s, 
                                                                            b: inputElement.value.trim(), 
                                                                            FOLIO_RC: '', 
                                                                            ID_RC: '', 
                                                                            ID_RAC: '', 
                                                                            tipoFiltro: 'buscador' 
                                                                        }));
                                                                    }
                                                                : () => {}
                                                                }                                                    
                                                            style={{ cursor: 'pointer', borderLeft: '0' }}
                                                            title="Buscar"
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </span>
                                                    : ''
                                                }
                                            </div>
                                        </div>
                                        {/* <div className=" col-md-2">
                                            <label style={{ fontWeight: 600, fontSize: 16 }} htmlFor="buscar">
                                                Folio
                                            </label>
                                            <input
                                                id="txtRegistro"
                                                type="text"
                                                className="form-control"
                                                name="buscar"
                                                aria-label=""
                                                aria-describedby="basic-addon1"
                                                value={filtros.FOLIO_RC? filtros.FOLIO_RC: ''}
                                                onChange={(e) => {
                                                    e.persist()
                                                    setFiltros((s) => ({ ...s, FOLIO_RC: e.target.value, tipoFiltro: 'buscador'}))
                                                }}
                                            />
                                        </div> */}
                                        <div className=" col-md-3">
                                            <label style={{ fontWeight: 600, fontSize: 16}} htmlFor="buscar">
                                                Tipo de carnet
                                            </label>
                                            <Select
                                                options={/*tipoCarnets*/[
                                                    { value: '1001-1001', label: 'Conferencia', clave: '1001-1001' },
                                                    { value: '1001-1002', label: 'Acceso Networking', clave: '1001-1002' },
                                                    { value: '1001-1003', label: 'Conferencia + Acceso Networking', clave: '1001-1003' },
                                                    { value: '1001-1004', label: '1er taller + Acceso Networking', clave: '1001-1004' },
                                                    { value: '1001-1005', label: '2do taller + Acceso Networking', clave: '1001-1005' },
                                                    { value: '6', label: 'Staff', clave: '6' },   
                                                    // { value: '4', label: 'Invitado Especial', clave: '4' }, // Invitado
                                                    // { value: '3', label: 'Expositor', clave: '3' }, // expositor
                                                    // { value: '4', label: 'VIP', clave: '4' },
                                                    // { value: '5', label: 'Asistente', clave: '5' }      
                                                    // { value: '11', label: 'Ponente', clave: '11' }, // speaker
                                                    { value: '19', label: 'Proveedor', clave: '19' } 
                                                ]}
                                                isMulti
                                                placeholder={"Tipo carnet"}
                                                value={selectTipoCarnet}
                                                onChange={onFiltroTipoCarnet}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 d-flex mb-sm-2 mb-3 justify-content-end align-self-end">
                                    <div className="flex justify-content-start align-self-center">
                                        <button type="button" className="btn btn-success" onClick={() => {
                                            window.document.getElementById('input_buscador').value = ''
                                            //evaluarEscribiendo({ target: { value: '' } })
                                            setFiltros((s) => ({ ...s, pagina: 0, b: '', FOLIO_RC: '', ID_RC: '', ID_RAC: '', tipoFiltro: 'buscador'}))
                                        }}>
                                            <i className="fa fa-refresh"></i> Limpiar filtro
                                        </button>
                                        {tipoRegistro == 1 || tipoRegistro == 2?
                                        <button type="button" className="btn btn-primary ml-2" onClick={() => {
                                            window.location.href = '/mesaregistro/nuevo'
                                        }}>
                                            <i className="fa fa-address-card" aria-hidden="true"></i> Nuevo registro
                                        </button>
                                        :''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" datatable-react mt-4" >
                            <TablaPro
                                cargando={false}
                                headers={[
                                    {
                                        nombre: 'Folio / Id', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return <div style={{ width: '15em' }}>
                                                <strong>{d.FECHA_ALTA_RAC_TEXT}</strong><br />
                                                <span className="text-info"><strong>{d.ID_RC}</strong>-<strong>{d.ID_RAC}</strong></span>
                                            </div>
                                        }
                                    },
                                    {
                                        nombre: 'Asistente/Empresa', tipo: 'html', texto: 'NOMBRES_DP', html: (d) => {
                                            return <div style={{width: '20em'}}>
                                                <strong>{d.NOMBRES_DP} {d.APELLIDOS_DP}</strong><br />
                                                <span className="text-info"><strong>{d.EMPRESA}</strong></span><br />
                                                {/* <span className="text-info" style={{color: 'black'}}> {
                                                d.CENA_BIENVENIDA.match(regex) != null && d.CENA_CLAUSURA.match(regex) != null ? `${d.CENA_BIENVENIDA} / ${d.CENA_CLAUSURA}`
                                                :d.CENA_BIENVENIDA.match(regex) != null && d.CENA_CLAUSURA.match(regex) == null ? `${d.CENA_BIENVENIDA}`
                                                :d.CENA_BIENVENIDA.match(regex) == null && d.CENA_CLAUSURA.match(regex) != null ? `${d.CENA_CLAUSURA}`
                                                : ''
                                                }</span> */}
                                            </div>
                                        }
                                    },
                                    {
                                        nombre: 'Contacto/Dirección', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return <div style={{ width: '20em' }}> 
                                                    {d.CORREO_DP ? <Fragment><strong>{d.CORREO_DP}</strong><br /></Fragment>:<Fragment>Sin correo<br/></Fragment>}
                                                    {d.WHATSAPP_DP ? <Fragment>Cel. {d.WHATSAPP_DP}<br/></Fragment>:<Fragment>Sin teléfono<br/></Fragment>}
                                                    {d.ESTADO ? <Fragment>{d.ESTADO}, Cd. {d.CIUDAD}</Fragment>:<Fragment>Sin dirección<br/></Fragment>}
                                            </div>
                                        }
                                    },
                                    {
                                        nombre: 'Tipo carnet', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return <div>
                                                {d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1001? 
                                                    <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                                                :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1002?
                                                    <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                                                :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1003?
                                                    <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                                                :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1004? 
                                                    <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                                                :d.TIPO_CARNET == 1 && d.ID_TIPO_SUBCARNET == 1005?
                                                    <h5><span className="badge badge-primary">{d.TIPO_SUBCARNET}</span></h5>
                                                :d.TIPO_CARNET === 2?
                                                    <img src="/talleres.jpg" width={150} />
                                                :d.TIPO_CARNET === 3? 
                                                    <img src="/Expositor.png" width={150} />
                                                :d.TIPO_CARNET === 4? 
                                                    <img src="/Invitado-Especial.png" width={150} />
                                                :d.TIPO_CARNET === 5? 
                                                    <img src="/prensa.jpg" width={150} />
                                                :d.TIPO_CARNET === 6? 
                                                    <h5><span className="badge badge-primary">STAFF</span></h5>
                                                :d.TIPO_CARNET === 7 || d.TIPO_CARNET === 8? 
                                                    <img src="/cena.jpg" width={150} />
                                                :d.TIPO_CARNET === 11? 
                                                    <img src="/Ponente.png" width={150} />
                                                :d.TIPO_CARNET === 12? 
                                                <img src="/patrocinador.jpg" width={150} />
                                                :d.TIPO_CARNET === 13? 
                                                <img src="/claec.jpg" width={150} />
                                                :d.TIPO_CARNET === 9? 
                                                <img src="/conferencias.jpg" width={150} />
                                                :d.TIPO_CARNET === 8? 
                                                <img src="/cena.jpg" width={150} />
                                                :d.TIPO_CARNET === 15?
                                                <img src="/convencionista-soloCB.jpg" width={150} />
                                                :d.TIPO_CARNET === 16?
                                                <img src="/convencionista-sinC.jpg" width={150} />
                                                :d.TIPO_CARNET === 17?
                                                <img src="/apoyo-speaker.jpg" width={150} />
                                                :d.TIPO_CARNET === 18?
                                                <h5><span className="badge badge-primary">PROVEEDOR</span></h5>
                                                :d.TIPO_CARNET === 19?
                                                <h5><span className="badge badge-primary">PROVEEDOR</span></h5>
                                                : <h5><span className="badge badge-primary">Carnet {d.TIPO_CARNET_TEXT}</span></h5>
                                                }
                                            </div>
                                        }
                                    },
                                    {
                                        nombre: 'Entrega kit', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return  d.KIT_ENTREGADO_RAC ?
                                                    <div style={{ width: '5em' }}>
                                                        <h6><span class="badge badge-success"><span>{d.KIT_ENTREGADO_TEXT}</span><br/><span class="badge badge-light mt-2" style={{fontSize: 10}}>{d.FECHA_KIT_ENTREGADO_TEXT}</span></span></h6>
                                                    </div> 
                                                    :
                                                    <div style={{ width: '5em' }}>
                                                        <h6><span class="badge badge-warning">{d.KIT_ENTREGADO_TEXT}</span></h6>
                                                    </div> 
                                        }
                                    },
                                     
                                    {
                                        nombre: 'Impresión acceso', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return <div style={{ width: '7.5em' }}>
                                                <Fragment>
                                                    {d.IMPRIMIO_CARNET_RAC ?
                                                        <h6><span class="badge badge-success"><span>{d.IMPRIMIO_CARNET_TEXT}</span><br/><span class="badge badge-light mt-2" style={{fontSize: 10}}>{d.ULTIMA_IMPRESION}</span></span></h6>
                                                        :
                                                        <h6><span class="badge badge-warning">{d.IMPRIMIO_CARNET_TEXT}</span></h6>
                                                    }
                                                </Fragment>
                                            </div>
                                        }
                                    },
                                    {
                                        nombre: 'Estatus pago', tipo: 'html', texto: 'ID_RAC', html: (d) => {
                                            return <div style={{ width: '10em' }}>
                                                <Fragment>
                                                    <div style={{textTransform: 'uppercase'}}>
                                                        {d.ESTATUS_DPG === -1 ?
                                                        <h6><span class="badge badge-dark">{d.ESTATUS_DPG_TEXT} Pago</span></h6>
                                                        : d.ESTATUS_DPG === 0 ?
                                                        <h6><span class="badge badge-danger">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                                                        : d.ESTATUS_DPG === 1 ?
                                                        <h6><span class="badge badge-light">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                                                        : d.ESTATUS_DPG === 2 ?
                                                        <h6><span class="badge badge-success">{d.ESTATUS_DPG_TEXT}</span></h6>
                                                        : d.ESTATUS_DPG === 3 ?
                                                        <h6><span class="badge badge-warning">Pago {d.ESTATUS_DPG_TEXT}</span></h6>
                                                        : d.ESTATUS_DPG === 4 ?
                                                        <h6><span class="badge badge-dark">{d.ESTATUS_DPG_TEXT}</span></h6>
                                                        : d.ESTATUS_DPG === 5 ?
                                                        <h6><span class="badge badge-info">{d.ESTATUS_DPG_TEXT}</span></h6>
                                                        :d.ESTATUS_DPG === 6 ?
                                                        <h6><span class="badge badge-info">{d.ESTATUS_DPG_TEXT}</span></h6>
                                                        :'Sin estatus'}
                                                    </div>
                                                </Fragment>
                                            </div>
                                        }
                                    },
                                    // { nombre: 'Fecha', tipo: 'individual', texto: 'FECHA_ALTA_RAC_TEXT' },
                                    {
                                        nombre: 'Detalles', tipo: 'html', texto: 'Detalle',
                                        html: (datos) => {
                                            return <div style={{ width: '10em' }}>
                                                <div class="btn-group dropstart dropleft">
                                                    <button
                                                        class="btn btn-secondary dropdown-toggle"
                                                        type="button"
                                                        id="dropdownMenuButton1"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        Opciones
                                                    </button>
                                                    <ul
                                                        class="dropdown-menu"
                                                        aria-labelledby="dropdownMenuButton1"
                                                    >
                                                        <li>
                                                            <a class="dropdown-item" href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setModalImpresion((s) => ({
                                                                        ...s,
                                                                        estado: !s.estado,
                                                                        datos: [{...datos, TIPO_QR: 1}]
                                                                    }));
                                                                }}
                                                            >Imprimir carnet</a>
                                                        </li>
                                                        <li>
                                                            <a className="dropdown-item" href="#"
                                                                onClick={async (e) => {
                                                                    e.preventDefault();
                                                                    try {
                                                                        const response = await fetch('/rt_mesa_registro', {
                                                                            method: 'POST',
                                                                            headers: { 'Content-Type': 'application/json' },
                                                                            body: JSON.stringify({ ID_RC: datos.ID_RC }) 
                                                                        });
                                                                        const result = await response.json();
                                                                        if (result.result && result.result.length > 0) {
                                                                            setModalImpresion((s) => ({
                                                                                ...s,
                                                                                estado: true,
                                                                                datos: result.result.map((v) => ({ ...v, FOLIO_RC: datos.ID_RC }))
                                                                            }));
                                                                        } else {
                                                                            tools.notie.alert({
                                                                                type: 'warning',
                                                                                text: 'No se encontraron registros grupales para este FOLIO_RC.',
                                                                                time: 3,
                                                                                position: 'top'
                                                                            });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error('Error al obtener datos grupales:', error);
                                                                        tools.notie.alert({
                                                                            type: 'error',
                                                                            text: 'Ocurrió un error al intentar obtener los datos grupales.',
                                                                            time: 3,
                                                                            position: 'top'
                                                                        });
                                                                    }
                                                                }}
                                                            >Imprimir grupo</a>
                                                        </li>
                                                        <li>
                                                            <a className="dropdown-item"
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    onEntregaKit(datos)                                                         
                                                                }}
                                                            >Entrega de kit</a>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    setModalEditar((s) => ({
                                                                        ...s,
                                                                        estado: !s.estado,
                                                                        datos
                                                                    }))
                                                                }}
                                                            >Editar asistente</a></li>
                                                        <li>
                                                            <a className="dropdown-item"
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    window.location.href = '/mesaregistro/editar/'+datos.ID_RC                                                           
                                                                }}
                                                            >Detalle del registro</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        }
                                    }
                                ]}
                                // row={{
                                //     ignoreColumns: ['Detalle'],
                                //     onClick: (e, datos) => {
                                //         setModalEditar((s) => ({
                                //             ...s,
                                //             estado: !s.estado,
                                //             datos
                                //         }))
                                //     }
                                // }}
                                totalField={'NR'} /* NR = número de resultados totales */
                                path={'./rt_mesa_registro'}
                                refresh={memoizedRefresh}
                                body={memoizedBody}
                                rowsPerPage={20}
                                paginadorTop={true}
                            ></TablaPro>
                        </div>
                    </div>
                </div>
                <ModalEditarCarnet
                    modal={modalEditar}
                    setModal={setModalEditar}
                    setEsRefresh={setEsRefresh}
                />
                <ModalImpresion
                    modal={modalImpresion}
                    setModal={setModalImpresion}
                    setEsRefresh={setEsRefresh}
                    onImprimir={onImprimir}
                    onImprimirBienvenida={onImprimirBienvenida}
                    onImprimirDinamica={onImprimirDinamica}
                    esImprimir={esImprimir}
                    esImprimirDinamica={esImprimirDinamica}
                />
            </Fragment>
        </div>
    );
};

export default memo(Default);
